'use strict';

angular.module('more.ui.form-builder').service('$paymentHelper', function () {
    return {};
});